// extracted by mini-css-extract-plugin
export default {"section":"styles_section__26lhw","description":"styles_description__Gut7N","styledAnchor":"styles_styledAnchor__HIEvt"};